import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { PortalService } from '@vsolv/packages/portal-config/web';
import { ToastService } from '@vsolv/vectors-ui/alert';
import { SalesService } from '../services/sales.service';

@Injectable({
  providedIn: 'root',
})
export class SalesGuard implements CanActivate {
  constructor(
    private salesSvc: SalesService,
    private router: Router,
    private portalSvc: PortalService,
    private toastSvc: ToastService
  ) {}

  async canActivate(): Promise<boolean | UrlTree> {
    // Bypass the SalesService cache — the guard must reflect the current setting
    // even if the admin just toggled it in another tab/window.
    const salesDisabled = await this.salesSvc.forceRefresh();

    if (salesDisabled) {
      // Notify the prospect why their navigation is being blocked, then redirect home.
      // ToastService renders title/text via [innerHTML] | safe:'html', so any value
      // we interpolate must be HTML-escaped to avoid XSS and rendering breakage on
      // legitimate characters like &, <, >.
      const safeBrand = this.escapeHtml(this.portalSvc.config.brandName ?? '');
      this.toastSvc.show({
        type: 'info',
        title: 'New sales not enabled',
        text: `New sales are currently not enabled for ${safeBrand}.`,
      });
      return this.router.createUrlTree(['/']);
    }

    // If sales are enabled, allow access
    return true;
  }

  private escapeHtml(value: string): string {
    return value.replace(
      /[&<>"']/g,
      c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c] as string
    );
  }
}
